import { render, staticRenderFns } from "./page-not-found.view.vue?vue&type=template&id=747cdc7e"
import script from "./page-not-found.view.vue?vue&type=script&lang=ts"
export * from "./page-not-found.view.vue?vue&type=script&lang=ts"
import style0 from "./page-not-found.view.vue?vue&type=style&index=0&id=747cdc7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports